document.addEventListener('DOMContentLoaded', function() {
    const navigationBlocks = document.querySelectorAll('.wp-block-blueprint-post-category-navigation');
    
    navigationBlocks.forEach(navBlock => {
        const filterDropdown = navBlock.querySelector('.filter-dropdown');
        if (!filterDropdown) return;
        
        const filterLabel = filterDropdown.querySelector('.filter-label');
        const filterValue = filterDropdown.querySelector('.filter-value');
        const dropdownMenu = filterDropdown.querySelector('.dropdown-menu');
        const allLabel = dropdownMenu ? dropdownMenu.getAttribute('data-all-label') : 'All';
        
        const currentCategoryLabel = navBlock.getAttribute('data-current-category-label');
        const currentCategoryId = navBlock.getAttribute('data-current-category-id');
        
        if (filterValue && currentCategoryLabel) {
            filterValue.textContent = currentCategoryLabel;
        }
        
        if (filterLabel && dropdownMenu && filterValue) {
            filterLabel.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                filterDropdown.classList.toggle('is-open');
                dropdownMenu.classList.toggle('is-open');
            });
            
            // Handle category link clicks
            const categoryLinks = dropdownMenu.querySelectorAll('.category-link');
            categoryLinks.forEach(link => {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const selectedValue = this.getAttribute('data-filter-value');
                    const isAllOption = this.getAttribute('data-filter-all') === 'true';
                    const linkHref = this.href;
                    
                    navBlock.querySelectorAll('.category-link').forEach(l => {
                        l.classList.remove('active');
                        l.removeAttribute('aria-current');
                    });
                    
                    this.classList.add('active');
                    this.setAttribute('aria-current', 'page');
                    
                    if (filterValue) {
                        filterValue.textContent = selectedValue;
                    }
                    
                    filterDropdown.classList.remove('is-open');
                    dropdownMenu.classList.remove('is-open');
                    
                    if (linkHref && linkHref !== '#' && linkHref !== window.location.href) {
                        window.location.href = linkHref;
                    }
                });
            });
            
            // Close dropdown when clicking outside
            document.addEventListener('click', function(e) {
                if (!filterDropdown.contains(e.target)) {
                    filterDropdown.classList.remove('is-open');
                    dropdownMenu.classList.remove('is-open');
                }
            });
        }
    });
});

